import { Link, useLocation } from "react-router-dom";
import { Phone, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackPhoneConversion } from "@/lib/analytics";

/**
 * Mobile-only sticky conversion bar. Local intent converts by tap-to-call,
 * so the phone number stays reachable from every scroll position.
 */
export function MobileCallBar() {
  const { pathname } = useLocation();

  // Keep the calculator's own CTAs unobstructed only where it would duplicate.
  const hidden = pathname.startsWith("/admin") || pathname.startsWith("/oauth");
  if (hidden) return null;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-accent/30 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      role="region"
      aria-label="Contact Lazona Tile Care"
    >
      <div className="grid grid-cols-2 gap-2 p-2">
        <a
          href="tel:4803520392"
          onClick={() => trackPhoneConversion("4803520392")}
          className="flex items-center justify-center gap-2 rounded-xl bg-accent px-3 py-3 font-display text-sm font-bold text-accent-foreground"
        >
          <Phone className="w-4 h-4" aria-hidden="true" />
          CALL NOW
        </a>
        <Button asChild variant="outline" className="h-auto min-h-12 px-2 whitespace-normal text-center text-xs sm:text-sm">
          <Link to={pathname === "/grout-color-sealing" ? "/grout-color-sealing#consultation" : "/contact#contact-form"}>
            <CalendarDays className="w-4 h-4 text-accent" aria-hidden="true" />
            Book A Consultation
          </Link>
        </Button>
      </div>
    </div>
  );
}

export default MobileCallBar;
